import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)
Vue.config.productionTip = false

new Vue({
  router: new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: [
      {path: '/', name: 'home', component: App},
      {path: '/:owner/:repo', name: 'repo', component: App},
      {path: '/:owner/:repo/:status', name: 'complete', component: App},
    ],
  }),
  render: h => h(App),
}).$mount('#app')
